import { useContext, useState } from "react";
import MDSpinner from "react-md-spinner";
import { AppContext } from "../../../Util/contexts/AppContext";

const ReportBugPage = ({ changeSettingsPage, setSuccessMessage }) => {
  const { userData, route, primaryColor, displayAuthenticationError } =
    useContext(AppContext);
  const [feedback, setFeedback] = useState("");
  const [submitFeedbackError, setSubmitFeedbackError] = useState(null);
  const [submitFeedbackLoading, setSubmitFeedbackLoading] = useState(false);

  const submitFeedbackHandler = async () => {
    setSubmitFeedbackLoading(true);
    await fetch(`${route}/feedback.webapi`, {
      method: "POST",
      headers: {
        Token: userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        CustomerId: userData.CustomerId,
        feedback: feedback,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else if (response.status === 401) {
          return displayAuthenticationError();
        } else {
          throw new Error();
        }
      })
      .then((response) => {
        setSuccessMessage("Thank you for your feedback.");
        changeSettingsPage("Settings");
      })
      .catch((error) => {
        console.log(error);
        setSubmitFeedbackError(`${error}`);
        setSubmitFeedbackLoading(false);
      });
  };

  return (
    <div
      className="accountSettingsBodyWrapper"
      id="ReportBug/Feedback"
      key="ReportBug/Feedback"
    >
      <div
        className="accountSettingsCard accountSettingsBigCard"
        key="Report Bug"
      >
        <h3 className="accountSettingsCardTitle">Report Bug/Feedback</h3>
        <p className="accountSettingsToggleDescription">
          Noticed a bug or have something to share with us? Let us know here.
        </p>
        <label for="feedback" className="standardLabel">
          Enter Feedback
        </label>
        <textarea
          type="text"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          id="feedback"
          autofill="none"
          className="standardTextArea"
        />
        {submitFeedbackError && (
          <p className="changePasswordErrorText">{submitFeedbackError}</p>
        )}
        {submitFeedbackLoading ? (
          <div className="accountSettingsCardButtonLoaderContainer">
            <MDSpinner size={35} singleColor={primaryColor} />
          </div>
        ) : (
          <div className="accountSettingsButtonWrapper">
            <button
              className="accountSettingsCancelButton secondaryButton"
              onClick={() => changeSettingsPage("Settings")}
            >
              Cancel
            </button>
            <button
              className="accountSettingsButton tertiaryButton"
              onClick={submitFeedbackHandler}
            >
              Confirm
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportBugPage;
